import { useNavigate } from 'react-router-dom';
import { Box, NotFoundPage, Spinner } from 'dash-ui';

import { useGetCurrentDeveloperUserQuery } from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';

import OrganizationDetailsHeader from './components/OrganizationDetailsHeader/OrganizationDetailsHeader';
import OrganizationDetailsTabs from './components/OrganizationDetailsTabs/OrganizationDetailsTabs';

function OrganizationDetailsPage() {
  const navigate = useNavigate();
  const { data, loading } = useGetCurrentDeveloperUserQuery();

  const currentDeveloper = data?.getCurrentDeveloperUser || null;
  const currentOrganization = currentDeveloper?.organizations?.[0];

  return (
    <Box>
      {loading && <Spinner size={32} fullContent />}
      {currentOrganization ? (
        <Box w="100%">
          <OrganizationDetailsHeader organization={currentOrganization} />
          <OrganizationDetailsTabs organizationId={currentOrganization._id} />
        </Box>
      ) : (
        <Box h={100}>
          <NotFoundPage onRedirect={() => navigate(RoutesPath.Home)} />
        </Box>
      )}
    </Box>
  );
}

export default OrganizationDetailsPage;
